export const ADDRESS = `
  _id
  description
  firstName
  lastName
  addressLine1
  addressLine2
  streetNumber
  city
  state
  postCode
  alpha2
  type
`;

export const USER = `
  _id
  id
  firstName
  lastName
  name
  email
  telephone
  taxNumber
  organisation
  addresses {
    ${ADDRESS}
  }
  isSubscribed
  preferences {
    notifications {
      backInStock {
        email
      }
    }
    preferredLanguage
  }
`;
